import type { LoyaltyProgramActionItem } from '../types';

export function buildLoyaltyNumbersPatchBody(items: LoyaltyProgramActionItem[]): Record<string, unknown>[] {
  return items
    .filter((item) => item.action === 'create' || item.action === 'update')
    .map((item) => {
      if (item.action === 'create') {
        return {
          category_id: item.category_id,
          number: item.number,
          loyalty_program: item.loyalty_program,
          frequent_flyer_number: item.frequent_flyer_number,
          note: item.note,
        };
      }
      return {
        id: item.id,
        category: item.category,
        number: item.number,
        loyalty_program: item.loyalty_program,
        frequent_flyer_number: item.frequent_flyer_number,
        note: item.note,
      };
    });
}
